import { render, staticRenderFns } from "./coachPanel.vue?vue&type=template&id=4ff96d7e&scoped=true&"
import script from "./coachPanel.vue?vue&type=script&lang=js&"
export * from "./coachPanel.vue?vue&type=script&lang=js&"
import style0 from "./coachPanel.vue?vue&type=style&index=0&id=4ff96d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff96d7e",
  null
  
)

export default component.exports